<div class="message-list" #list (scroll)="onScroll($event)">
  @for (message of messages(); track message.id) {
    <article
      class="message"
      [class.own]="ownMessage(message)"
      [class.audio-only]="isAudioOnly(message)"
    >
      <div class="message-meta">
        <strong>{{ displayedSender(message) }}</strong>
        <span class="message-meta-details">
          <time>{{ message.createdAt | date: "medium" }}</time>
          @if (readState(message); as state) {
            <span
              class="message-read-status"
              [class.read]="state === 'read'"
              [attr.aria-label]="state === 'read' ? readLabel() : sentLabel()"
              [attr.title]="state === 'read' ? readLabel() : sentLabel()"
            >
              <span class="message-read-checks" aria-hidden="true">
                <span>✓</span>
                @if (state === "read") {
                  <span>✓</span>
                }
              </span>
              <span>{{ state === "read" ? readLabel() : sentLabel() }}</span>
            </span>
          }
        </span>
      </div>
      @if (message.text) {
        <p>{{ displayedText(message) }}</p>
        @if (isLong(message)) {
          <button
            class="message-toggle"
            type="button"
            (click)="toggle(message.id)"
          >
            {{
              expandedMessageIds().has(message.id)
                ? seeLessLabel()
                : seeMoreLabel()
            }}
          </button>
        }
      }
      @if (
        message.audioUrl || message.videoUrl || message.attachments?.length
      ) {
        <div class="message-media">
          @if (message.audioUrl) {
            <audio
              controls
              preload="metadata"
              [src]="mediaUrl()(message.audioUrl)"
              (loadedmetadata)="ensureAudioDuration($event)"
            ></audio>
          }
          @if (message.videoUrl) {
            <video
              controls
              preload="metadata"
              [src]="mediaUrl()(message.videoUrl)"
              (loadedmetadata)="videoMetadataLoaded()"
            ></video>
          }
          @if (message.attachments?.length) {
            @let groups = groupedAttachments(message);
            @if (groups.images.length) {
              <div
                class="image-gallery"
                [class.single-image]="groups.images.length === 1"
              >
                @for (attachment of groups.images; track attachment) {
                  <a
                    class="image-attachment"
                    [href]="mediaUrl()(attachment)"
                    [attr.aria-label]="'Preview image ' + fileName(attachment)"
                    (click)="openImage(attachment, $event)"
                  >
                    <img
                      [src]="mediaUrl()(attachment)"
                      [alt]="fileName(attachment)"
                      loading="lazy"
                    />
                  </a>
                }
              </div>
            }
            @if (groups.documents.length) {
              <div class="document-list">
                @for (attachment of groups.documents; track attachment) {
                  <div class="document-row">
                    <span class="document-icon"
                      ><ng-icon name="page" size="19"
                    /></span>
                    <span class="document-name" [title]="fileName(attachment)">
                      {{ fileName(attachment) }}
                    </span>
                    <span class="document-actions">
                      <button
                        type="button"
                        (click)="openDocument(attachment, $event)"
                      >
                        {{ openLabel() }}
                      </button>
                      <a
                        [href]="mediaUrl()(attachment)"
                        [download]="fileName(attachment)"
                        >{{ downloadLabel() }}</a
                      >
                    </span>
                  </div>
                }
              </div>
            }
          }
        </div>
      }
    </article>
  } @empty {
    <div class="empty-state">{{ emptyLabel() }}</div>
  }
</div>
